import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cedipOptions, stateActivePendient } from "util/cedip";
import { actions as cedipActions } from "reducers/cedip";
import { today, date7DaysAfter, date7DaysBefore } from "pages/deposits/utils";

export const useCedipTabs = (tabIndex) => {
    const { optionCedip, cedipFilters } = useSelector((state) => state.cedip);
    const { prevRoute } = useSelector((state) => state.form);
    const { prevPath } = prevRoute;

    const dispatch = useDispatch();
    const isTabSelected = optionCedip === cedipOptions[tabIndex];
    const cleanFilter = !prevPath.includes("depositsCedip");

    useEffect(() => {
        dispatch(cedipActions.setCedipOption(cedipOptions[tabIndex]));
    }, [dispatch]);

    useEffect(() => {
        const myCedipFilters = {
            createdFrom: date7DaysBefore,
            createdTo: today,
            expiredFrom: today,
            expiredTo: date7DaysAfter,
            status: "TODOS",
            pageNumber: 1,
            tabSelected: "ALL",
        };

        const receivedCedipFilters = {
            createdFrom: date7DaysBefore,
            createdTo: today,
            expiredFrom: today,
            expiredTo: date7DaysAfter,
            status: stateActivePendient,
            pageNumber: 1,
            tabSelected: "REC",
        };

        const transmitedCedipFilters = {
            createdFrom: date7DaysBefore,
            createdTo: today,
            expiredFrom: today,
            expiredTo: date7DaysAfter,
            status: stateActivePendient,
            pageNumber: 1,
            tabSelected: "TRA",
        };

        if (!isTabSelected || Object.keys(cedipFilters).length === 0 || cleanFilter) {
            switch (tabIndex) {
                case 0:
                    dispatch(cedipActions.setCedipFilters(myCedipFilters));
                    dispatch(cedipActions.filterCedipList({ ...myCedipFilters }));
                    break;
                case 1:
                    dispatch(cedipActions.setCedipFilters(receivedCedipFilters));
                    dispatch(cedipActions.filterCedipList({ ...receivedCedipFilters }));
                    break;
                case 2:
                    dispatch(cedipActions.setCedipFilters(transmitedCedipFilters));
                    dispatch(cedipActions.filterCedipList({ ...transmitedCedipFilters }));
                    break;
                default:
                    dispatch(cedipActions.setCedipFilters(myCedipFilters));
                    dispatch(cedipActions.filterCedipList({ ...myCedipFilters }));
                    break;
            }
        } else {
            dispatch(cedipActions.filterCedipList({ ...cedipFilters }));
        }
    }, [dispatch, optionCedip]);
};

export default useCedipTabs;
